import { RadioButton } from './RadioButton'

interface RadioOption {
  value: string
  label: string
  infoText?: string
  disabled?: boolean
}

interface RadioGroupProps {
  name: string
  options: RadioOption[]
  value?: string
  onChange?: (value: string) => void
  error?: boolean
  errorMessage?: string
  className?: string
  orientation?: 'vertical' | 'horizontal'
}

export function RadioGroup({
  name,
  options,
  value,
  onChange,
  error = false,
  errorMessage,
  className = '',
  orientation = 'vertical',
}: RadioGroupProps) {
  const handleChange = (optionValue: string) => {
    if (onChange) {
      onChange(optionValue)
    }
  }

  return (
    <div
      className={`${
        orientation === 'horizontal'
          ? 'flex flex-row gap-3'
          : 'flex flex-col gap-3'
      } ${className}`}
      role='radiogroup'
    >
      {options.map(option => (
        <RadioButton
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          {...(option.infoText ? { infoText: option.infoText } : {})}
          checked={value === option.value}
          {...(option.disabled ? { disabled: option.disabled } : {})}
          onChange={() => handleChange(option.value)}
          error={error}
        />
      ))}
      {error && errorMessage && (
        <div className='text-sm text-red-600 mt-0.5'>{errorMessage}</div>
      )}
    </div>
  )
}
